export default __webpack_public_path__ + "static/media/check.ba73a04a.svg";